import styled from "@emotion/styled";
import { TextField } from "@mui/material";

export default styled(TextField)({
  "& label.Mui-focused": {
    color: "#f2006c !important",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#f2006c",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#f2006c",
    },
    "&:hover fieldset": {
      borderColor: "#f2006c",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#f2006c",
    },
    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
      display: "none",
    },
    "& input[type=number]": {
      MozAppearance: "textfield",
    },
    "& input:-webkit-autofill": { 
      WebkitTextFillColor: "black", 
      transition: "background-color 5000s ease-in-out 0s",
      caretColor: "white"
    }, 
  },
});
